import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import Text from "../../../../../components/theme/text/Text";
import { tokens } from "../../../../../theme";
import MpAddOrder from "../../../../../components/global/ModalsProgression/MpAddOrder/MpAddOrder";

import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import OrdersCard from "../../../../../components/global/cards/orders/OrdersCard";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShCopyButton from '../../../../../components/theme/ShCopy';
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetOrdersQuery } from "../../../../../newapi/order/ordersSlice";
import { getOrderStateData } from "../../../../../utils/labelColorText";
import { general_states } from '../../../../../utils/staticEnums';
import { ORDER_FILTER_KEYS } from '../../../../../components/global/DataGrid/Filter';
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import SHQuickAction from '../../../../../components/theme/Modal/SHQuickAction';
import { SwapHorizOutlined } from '@mui/icons-material';
import { formatPrice } from '../../../../../utils/helpers';

const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return props.hasCreatePermission ?
        <ButtonGroup version={2}>
             <Shbutton 
                className={"group-btn"} 
                color={"secondary"} 
                onClick={() => props.toggleShowAll()}
                endIcon={<SwapHorizOutlined/>}
                variant="contained"
            >
                {props.showAll ? t('toggle_show_open') : t('toggle_show_all')}
            </Shbutton>
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_order')}
            </Shbutton>
           
        </ButtonGroup> : <></>
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [ORDER_FILTER_KEYS.ALL_STATES],
};

const RelationOrders = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();
    const [config,setConfig] = useState({relationId: props.relation, [ORDER_FILTER_KEYS.STATE.backend_key]:  [general_states.OPEN, general_states.PICKING_IN_PROGRESS, general_states.FULLYPICKED, general_states.ECHECK, general_states.ECHECKPAUSED], stateAll: false});
    const [showAll, setShowAll] = useState(false);

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.OUTBOUND_MANAGE])
    );

    const hasInvoicePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INVOICE_MANAGE, UserPrivileges.INVOICE_READ])
    );
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const toggleShowAll = () => {
        setShowAll(!showAll);
    }

    // Update config when relation prop changes
    useEffect(() => {
        setConfig(prevConfig => ({
            ...prevConfig,
            relationId: props.relation
        }));
        // Clear data when switching relations to prevent old data from showing
        setData([]);
    }, [props.relation]);

    // The totals panel lives above the tab view, in the parent, and belongs to this tab only.
    // Report that this tab is open so it shows, and that it closed so it goes away again.
    useEffect(() => {
        props.onActiveChange?.(true);

        return () => props.onActiveChange?.(false);
    },[]);

    useEffect(() => {
        if(config.stateAll !== showAll) {
            setConfig(prevConfig => ({
                ...prevConfig,
                stateAll: showAll,
                [ORDER_FILTER_KEYS.STATE.backend_key]: showAll ? [] : [general_states.OPEN, general_states.PICKING_IN_PROGRESS, general_states.FULLYPICKED, general_states.ECHECK, general_states.ECHECKPAUSED]
            }));
        }
    },[showAll]);

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const [defaultTab, setDefaultTab] = useState(null);
    const handleClose = (response) => {
        setAddModalOpen(false);
        const newOrderState = response?.data?.state ?? response?.state;
        const newOrderId = response?.data?.id ?? response?.id;
        if (newOrderState === general_states.ACTION_REQUIRED_CUSTOMER && newOrderId) {
            if (!spLoading) setSpLoading(true);
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId;
            setDefaultTab(2);
            setIsExtended(true);
        }
    };

    // console.log("index from order:", index);
    // console.log("id from order:", id);
    const ref = useRef();

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions handleOpen={handleOpen} hasCreatePermission={hasCreatePermission} toggleShowAll={toggleShowAll} showAll={showAll}></GridActions>,
        });

        return () => {
            
        }
    },[]);

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params) return;
    
        const neworderId = parseInt(params.row.id);
        // Only update state if the orderId has actually changed
        if (orderIdRef.current !== neworderId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(neworderId);
            orderIdRef.current = neworderId; // Update the ref to the new value
        }
        setDefaultTab(null);
        setIsExtended(true);
    };


    const columns = [
        {
            field: "barcode",
            headerName: t('order'),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.barcode}</Text>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.barcode}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "deliveryName", headerName: t("name"),flex:1, 
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.deliveryName
            }
        },
        {field: "webshopreference", headerName: t("webshopreference"),flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{`${params.row.webshopreference} (${params.row.deliveryCountry ? params.row.deliveryCountry.toUpperCase() : ""})`}</Text>)
            }
        },
        {
            field: "date_planned", 
            headerName: t("date_planned_shipment"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {

                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                let labelcolor = "grey";
                let planned = new Date(params.row.date_planned);
                let sent = params.row.date_sent ? new Date(params.row.date_sent) : null;
                let latestHandoverDateTime = params.row.latestHandoverDateTime ? new Date(params.row.latestHandoverDateTime) : null;

                if(sent) {
                    // when sent is filled and is equal to planned: green
                    if(sent.getTime() === planned.getTime()) {
                        labelcolor = "green";
                    }
                    // when sent is filled but later than planned: orange
                    else if(sent.getTime() > planned.getTime()) {
                        labelcolor = "orange";
                    }
                }
                else {
                    // When sent is not filled and planned >= now: blue
                    if(planned.setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)) {
                        labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
                    } else if(latestHandoverDateTime && (new Date().setHours(0,0,0,0) < latestHandoverDateTime)) {
                        labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
                    // When sent is not filled and planned < now: red
                    } else if(planned.setHours(0,0,0,0) < new Date().setHours(0,0,0,0)) {
                        labelcolor = "red";
                    }
                }
              
                return (
                    <SHQuickAction
                        component={ params.row.latestHandoverDateTime !== null ?
                            <Box
                                sx={{
                                    px:1.5,
                                    display:"flex",
                                    flexDirection:"column"
                                }}
                            >
                                <Text light>{t("handover_date")}</Text>
                                <Text>
                                    { new Date(params.row.latestHandoverDateTime).toLocaleDateString(i18n.language)}&nbsp;
                                    <b>
                                    {new Date(params.row.latestHandoverDateTime).toLocaleTimeString(i18n.language, {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                    </b>
                                </Text>
                            </Box>
                            : 
                            null
                        }
                    >
                        {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                            <Box
                                aria-owns={anchorEl ? 'simple-popover' : undefined}
                                aria-haspopup={false}
                                onMouseEnter={params.row.latestHandoverDateTime !== null ? onMouseEnter : null}
                                onMouseLeave={params.row.latestHandoverDateTime !== null ? onMouseLeave : null}
                                onTouchStart={params.row.latestHandoverDateTime !== null ? onTouchStart : null}
                                sx={{
                                    width:1,
                                }}
                            >
                                <ShLabel clickable size={32} fitted variant={labelcolor} palette="normal">
                                    {!sent && planned.toLocaleDateString(i18n.language)}
                                    {sent && sent.toLocaleDateString(i18n.language)}
                                </ShLabel>
                            </Box>
                        )}
                    </SHQuickAction>
                );
            }
        },
        {field: "orderlinesCount", headerName: t("orderlines_count"),flex:1,
            sortable:false,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.amountOfLines
        }},
        {field: "stream", headerName: t("stream"),flex:1,

            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.stream?.shortName
            }
        },
        {field: "shipper", headerName: t("shipper_name"),flex:2,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return `${params.row.shipper?.name ?? ""} - ${params.row.shipperprofile?.name ?? ""}`
        }},
        ...hasInvoicePermission ? [{field: "totalCost", headerName: t("total_price"),flex:1, 
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return !params.row.totalCost || parseInt(params.row.totalCost) === 0 ? "" : formatPrice(i18n, parseFloat(params.row.totalCost));
            }
        }] : [],
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            filter: ORDER_FILTER_KEYS.STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                
                const { labelcolor, labeltext } = getOrderStateData(params.row.state, theme);
              
                return (
                    <SHQuickAction
                    component={ params.row.skipReason !== null ?
                        <Box
                            sx={{
                                px:1.5,
                                display:"flex",
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("reason_to_skip")}</Text>
                            <Text>
                                {params.row.skipReason}
                            </Text>
                        </Box>
                        : 
                        null
                    }
                >
                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                        <Box
                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                            aria-haspopup={false}
                            onMouseEnter={params.row.skipReason !== null ? onMouseEnter : null}
                            onMouseLeave={params.row.skipReason !== null ? onMouseLeave : null}
                            onTouchStart={params.row.skipReason !== null ? onTouchStart : null}
                            sx={{
                                width:1,
                            }}
                        >
                             <ShLabel clickable size={32} palette="normal" variant={labelcolor}>
                                {t(labeltext)}
                            </ShLabel>
                        </Box>
                    )}
                </SHQuickAction>

                    // <ShLabel size={32} palette="normal" variant={labelcolor}>
                    //   {t(labeltext)}
                    // </ShLabel>
                  );
              }
        },
        {
            field: "createdAt", 
            headerName: t("date_created"),
            flex:1,
            filter: ORDER_FILTER_KEYS.STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                const date = new Date(params.row.createdAt);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <span>
                        {dateStr}{' '}<Text light>{timeStr}</Text>
                    </span>
                );
              }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <OrdersCard onClick={() => getOrderDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}  />
                )
            }
        }
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2 //key={theme.palette.mode}
                //pollingInterval={true}
                key={`${config.relationId}-${config.stateAll}`}
                content={useGetOrdersQuery}
                config={config}
                title={t('orders')}
                gridActions={<GridActions handleOpen={handleOpen} hasCreatePermission={hasCreatePermission} toggleShowAll={toggleShowAll} showAll={showAll}></GridActions>} 
                gridOptions={gridOptions} 
                sortModel={{field: columns[9].field,type:"DESC"}}
                columns={columns}
                rows={data}
                onRowClick={getOrderDetails}>
            </ShDataGrid2>
            {spLoading &&
                <SpOrderDetails
                    defaultTab={defaultTab}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    orderId={orderId}
                /> 
            }
            <MpAddOrder onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />
        </Box>
    );
}

export default RelationOrders;